import { useTranslation } from 'react-i18next';

import ControlledNumericField from '../../../../../shared/ControlledFields/ControlledNumericField';

const DetailOverViewSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <ControlledNumericField
      name="batch_id"
      variant="outlined"
      label={t('batchId')}
      step={1}
    />
  );
};

export default DetailOverViewSection;
